const routes = [
    {
        path: "/evaluations",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "evaluation_index"
        }
    },

    {
        path: "/evaluation/assessments/:id",
        component: () => import("../pages/EvaluationAssesment/EvaluationAssesment.vue"),
        meta: {
            isAuthenticated: true,
            permission: "evaluationassessment_index"
        }
    }

];

export default routes;
